<template>
    <div style="text-align: center">
        <ContentRenderer :content="outtrocontent"></ContentRenderer>
        <v-btn color="primary" @click="next()">{{$t('general.continue')}}</v-btn>
    </div>
</template>

<script>
  import ContentRenderer from "../content/ContentRenderer";
  import applicationEventHub from "../../events/applicationEventHub";
  export default {
    name: "JourneyPhaseOuttro",
    props:{
      outtrocontent:{required:true}
    },
    components:{
      ContentRenderer
    },
    mounted(){
      applicationEventHub.frameworkNavigationDisplay(true);
      applicationEventHub.$on('framework.next',this.next);
      applicationEventHub.frameworkButtonState(true,false);
    },
    methods:{
      next(){
        this.$emit('complete');
      }
    },
    beforeDestroy() {
      applicationEventHub.$off('framework.next',this.next);
      applicationEventHub.frameworkButtonState(true,true);
      applicationEventHub.frameworkNavigationDisplay(false);
    }
  }
</script>

<style scoped>

</style>